import { actionTypes } from "../epics";

const preloadedUserProfile = {
  loading: true,
  error: null,
  data: {},
};

export const userProfileReducer = (state = preloadedUserProfile, action) => {
  switch (action.type) {
    case actionTypes.FETCH_USER_PROFILE:
      return {
        loading: true,
        error: null,
        data: state.data,
      };
    case actionTypes.FETCH_USER_PROFILE_FAILURE:
      return {
        loading: false,
        error: action.payload,
        data: state.data,
      };
    case actionTypes.FETCH_USER_PROFILE_SUCCESS:
      return {
        loading: false,
        error: null,
        data: action.payload || {},
      };
    default:
      return state;
  }
};
